import { Switch } from "antd"
import { SunFilled, MoonFilled } from "@ant-design/icons"

type Props = {
  isDarkMode: boolean
  onToggle: (checked: boolean) => void
}

export const ThemeSwitcher: React.FC<Props> = ({ isDarkMode, onToggle }) => (
  <Switch
    checked={isDarkMode}
    checkedChildren={<MoonFilled />}
    unCheckedChildren={<SunFilled />}
    onChange={onToggle}
  />
)
